import contract from '@mailobj-browser/front/js/contracts/contract.js'
import add from './add/add.js'

export default contract({
  add
})